var lib = { };

lib.URL = function (service) {

    let PARTNER_STAG_URL = "https://api-partner.safe2pay-h.com.br/v2";
    let PARTNER_PROD_URL = "https://api-partner.safe2pay.com.br/v2";
    let PARTNER_LOCAL_URL = "http://localhost:53760/v2";

    if (isStaging()) {
        return PARTNER_STAG_URL + service;
    } else if (isLocal()) {
        return PARTNER_LOCAL_URL + service;
    } else
        return PARTNER_PROD_URL + service;

}
lib.AuthURL = function (service) {

    let AUTH_STAG_URL = "https://api-partner.safe2pay-h.com.br/v2";
    let AUTH_PROD_URL = "https://api-partner.safe2pay.com.br/v2";
    let AUTH_LOCAL_URL = "http://localhost:53760/v2";

    if (isStaging()) {
        return AUTH_STAG_URL + service;
    } else if (isLocal()) {
        return AUTH_LOCAL_URL + service;
    } else
        return AUTH_PROD_URL + service;
}

function isStaging() {
    return window.location.host.indexOf('-h') >= 0;
}

function isLocal() {
    return window.location.host.indexOf('local') >= 0;
}

module.exports = lib




// WEBPACK FOOTER //
// ./src/libs/ApiHandler.js